import React, { useEffect, useState } from "react";
import SmsSection from "../../../components/Settings/sms/SmsSection";
import useSmsTemplate from "../../../hooks/useSmsTemplate";
import { CircularProgress } from "@mui/material";
import AddTemplateModal from "./AddTemplateModal";
const TABS = [
  "Flights",
  "Hotels",
  "Tours",
  "Insurance",
  "Wallet",
  "White-label",
  "Invoice",
  "Extras",
];
export default function NotificationSettings() {
  const [selectedValue, setSelectedValue] = useState("core");
  const [isOpen, setIsOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const { getSmsTemplates } = useSmsTemplate();
  const [data, setData] = useState([]);
  const [addModalOpen, setAddModalOpen] = useState(false);
  const [affect, setAffect] = useState(0);
  const [editItem, setEditItem] = useState({});
  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const response = await getSmsTemplates(setLoading);
        setData(Array.isArray(response) ? response : []);
      } catch (error) {
        console.error("Failed to fetch SMS templates:", error);
        setData([]);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [affect]);
  const grouped = data.reduce((acc, item) => {
    acc[item.type] = acc[item.type] || [];
    acc[item.type].push(item);
    return acc;
  }, {});
  console.log(grouped);
  const options = [
    { value: "core", label: "Core Booking & Payment Notifications" },
    { value: "marketing", label: "Marketing & Promotions" },
    { value: "security", label: "Security Alerts" },
    { value: "updates", label: "App Updates" },
  ];
  const handleSelect = (value) => {
    setSelectedValue(value);
    setIsOpen(false);
  };
  const selectedOption = options.find(
    (option) => option.value === selectedValue
  );
  return (
    <>
      <div className="min-h-screen bg-gray-100 p-6 font-sans">
        <div className="flex space-x-4 mb-6 border-y-2 border-gray-200 py-5">
          {TABS?.map((tab) => (
            <button
              key={tab}
              className={`px-7 py-2 rounded-md text-sm font-medium shadow-sm ${
                tab === "Flights"
                  ? "bg-[#4E5662] text-white"
                  : "bg-white text-[#4E5662]"
              }`}
            >
              {tab}
            </button>
          ))}
        </div>
        <div className="flex justify-between items-center">
          <div className="max-w-sm px-3 my-3 relative">
            <div
              className="border border-gray-300 px-4 py-2 rounded-lg w-full cursor-pointer bg-white shadow-sm hover:border-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-colors duration-200 flex justify-between items-center"
              onClick={() => setIsOpen(!isOpen)}
            >
              <span className="text-gray-700">{selectedOption.label}</span>
              <svg
                className={`w-5 h-5 text-gray-500 transition-transform duration-200 ${
                  isOpen ? "rotate-180" : ""
                }`}
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M19 9l-7 7-7-7"
                />
              </svg>
            </div>
            {isOpen && (
              <div className="absolute z-10 w-full mt-1 bg-white border border-gray-300 rounded-lg shadow-lg max-h-60 overflow-auto">
                {options?.map((option) => (
                  <div
                    key={option.value}
                    className="px-4 py-2 cursor-pointer hover:bg-gray-100 text-gray-700 transition-colors duration-150"
                    onClick={() => handleSelect(option.value)}
                  >
                    {option.label}
                  </div>
                ))}
              </div>
            )}
          </div>
          <div>
            <button
              className="bg-primary1 px-4 py-2 text-white rounded-md"
              onClick={() => setAddModalOpen(true)}
            >
              Add Template
            </button>
          </div>
        </div>
        {loading ? (
          <div className="flex items-center justify-center">
            <CircularProgress />
          </div>
        ) : data.length === 0 ? (
          <div className="text-center text-gray-500 mt-10 text-2xl">
            No templates available.
          </div>
        ) : (
          <div className="flex flex-col space-y-3">
            {grouped?.TEXT?.length > 0 && (
              <SmsSection
                title="SMS"
                items={grouped?.TEXT}
                setAffect={setAffect}
                setAddModalOpen={setAddModalOpen}
                setEditItem={(item) => {
                  setEditItem(item);
                }}
              />
            )}
            {grouped?.WHATSAPP?.length > 0 && (
              <>
                <hr className="border-b border-gray mx-4" />
                <SmsSection
                  title="WHATSAPP"
                  items={grouped?.WHATSAPP}
                  setAddModalOpen={setAddModalOpen}
                  setAffect={setAffect}
                  setEditItem={(item) => {
                    setEditItem(item);
                  }}
                />
              </>
            )}
          </div>
        )}
      </div>
      <AddTemplateModal
        open={addModalOpen}
        onClose={() => {
          setAddModalOpen(false);
          setEditItem(null);
        }}
        setAffect={setAffect}
        initialData={editItem}
        setEditItem={setEditItem}
      />
    </>
  );
}
